/**
 * SORA Keep shopping — Dyson-style recently viewed product bar.
 * Saves last PDP viewed; shows "Continue here" when browsing elsewhere.
 */
(function () {
  var KEY = "sora_keep_shopping_v1";
  var DISMISS_KEY = "sora_keep_shopping_dismiss_v1";
  var DISMISS_MS = 1000 * 60 * 60 * 12; // 12h

  function read(key) {
    try {
      return JSON.parse(localStorage.getItem(key) || "null");
    } catch (e) {
      return null;
    }
  }

  function write(key, val) {
    try {
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) {}
  }

  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : "";
  }

  function isDismissed(handle) {
    var d = read(DISMISS_KEY);
    if (!d || d.handle !== handle) return false;
    return Date.now() - (d.at || 0) < DISMISS_MS;
  }

  function dismiss(handle) {
    write(DISMISS_KEY, { handle: handle, at: Date.now() });
  }

  function saveFromPage() {
    var el = document.querySelector("[data-sora-keep-product]");
    if (!el) return;
    var data = {
      handle: el.getAttribute("data-handle") || "",
      title: el.getAttribute("data-title") || "",
      url: el.getAttribute("data-url") || "",
      image: el.getAttribute("data-image") || "",
      at: Date.now(),
    };
    if (!data.handle || !data.url) return;
    write(KEY, data);
  }

  function showBar(data) {
    var bar = document.querySelector("[data-sora-keep]");
    if (!bar || !data) return;

    var img = bar.querySelector("[data-keep-image]");
    var title = bar.querySelector("[data-keep-title]");
    var ctas = bar.querySelectorAll("[data-keep-cta]");

    if (img) {
      img.src = data.image || "";
      img.alt = data.title || "";
      img.hidden = !data.image;
    }
    if (title) title.textContent = data.title || "this product";
    ctas.forEach(function (cta) {
      cta.href = data.url;
      if (cta.classList.contains("sora-keep__cta")) {
        cta.setAttribute("aria-label", "Continue shopping for " + (data.title || "product"));
      }
    });

    bar.hidden = false;
    bar.classList.add("is-visible");
    bar.setAttribute("data-keep-handle", data.handle);

    var close = bar.querySelector("[data-keep-close]");
    if (close && !close._bound) {
      close._bound = true;
      close.addEventListener("click", function () {
        dismiss(data.handle);
        bar.classList.remove("is-visible");
        bar.hidden = true;
      });
    }
  }

  function init() {
    // Always record when on a product page (snippet present)
    saveFromPage();

    var saved = read(KEY);
    if (!saved || !saved.handle || !saved.url) return;

    var here = currentHandle();
    // Hide while viewing that same product
    if (here && here === saved.handle) return;
    if (isDismissed(saved.handle)) return;

    // Small delay so it doesn't fight first paint / newsletter
    window.setTimeout(function () {
      showBar(saved);
    }, 900);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
